import './scripts/global';
import './scripts/animations/animations';

import './scripts/layout/site-menu';
import './scripts/layout/homepage';
import './scripts/components/component-champions-card';
import './scripts/components/component-scrolling-text';
import './scripts/components/component-swiper';


